import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  nameFieldWrapper: {
    marginTop: ['unset', '!important']
  }
})

export default useStyles
